import React, { useContext, useEffect } from "react";
import { ModalContext } from "../../ModalContext";
import doneIcon from "../../../static/icons/done.svg";
import errorIcon from "../../../static/icons/error.svg";
import "./response.scss";
const ResponseModal = ({ text, positive }) => {
  const { handleModal } = useContext(ModalContext);
  useEffect(() => {
    const timer = setTimeout(() => {
      handleModal();
    }, 1500);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  return (
    <div className="response_modal">
      <img src={positive ? doneIcon : errorIcon} alt="" />
      <p className="modal_title">{text}</p>
    </div>
  );
};

export default ResponseModal;
